import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterStateSnapshot } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InitService } from './modules/shared/init.service';
import { Constant } from './modules/shared/constants';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SharedModule } from './modules/shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FilterDialogComponent } from './filter-dialog/filter-dialog.component';
import { ColumnFilterDialogComponent } from './column-filter-dialog/column-filter-dialog.component';

import { AdvisorsTreeFilterModule } from './modules/shared/advisors-tree-filter/advisors-tree-filter.module';
import { LoaderComponent } from './modules/shared/loader/loader.component';
import { LoaderInterceptor } from './modules/shared/loader/loaderInterceptor';


export function loggerCallback(logLevel: any, message: string) {
  if (logLevel === LogLevel.Error) {
    console.error('[msal]', message);
  } else if (logLevel === LogLevel.Warning) {
    console.warn('[msal]', message);
  }
}

export function initApp(initsvc: InitService) {
  return (): Promise<any> => {
    if (window.location.href.indexOf("4200") > 0) {
      return initsvc.getConfigLocal();
    } else {
      return initsvc.getConfig();
    }
  }
}

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
export const _protectedResourceMap: [string, string[]][] = [[Constant.config.apiBaseUrl, Constant.config.scopes]];

export function MSALInstanceFactory(): IPublicClientApplication {
  console.log(Constant.config);
  const instance = (Constant.config.instance || '').replace(/\/+$/, '');
  const tenant = (Constant.config.tenant || '').replace(/^\/+/, '');

  return new PublicClientApplication({
    auth: {
      clientId: Constant.config.clientId,
      //redirectUri: window.location.origin + "/signin-oidc",
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      authority: `${instance}/${tenant}`
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    },
    
    system: {
      allowPlatformBroker: false,
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Error,
        piiLoggingEnabled: false
      }
      
    }
  });
}



export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  const apiBase = (Constant.config.apiBaseUrl || '').replace(/\/+$/, '');
  const apiEnv = (Constant.config.apiEnvUrl || '').replace(/\/+$/, '');

  if (apiBase) {
    protectedResourceMap.set(`${apiBase}/*`, Constant.config.scopes);
  }
  if (apiEnv) {
    protectedResourceMap.set(`${apiEnv}/*`, Constant.config.scopes);
  }

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: (_authService, state: RouterStateSnapshot) => ({
      scopes: Constant.config.scopes,
      redirectStartPage: `${window.location.origin}/#${state.url}`
    })
  };
}

@NgModule({
  declarations: [
    AppComponent,
 
    FilterDialogComponent,
    ColumnFilterDialogComponent,
    LoaderComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AdvisorsTreeFilterModule,
    AppRoutingModule,
    SharedModule,
    MsalModule
    
  ],
  providers: [ 
  provideHttpClient(withInterceptorsFromDi()),
  { provide: APP_INITIALIZER, useFactory: initApp, deps: [InitService], multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
  { provide: MSAL_INSTANCE,useFactory: MSALInstanceFactory},
  { provide: MSAL_GUARD_CONFIG,useFactory: MSALGuardConfigFactory},
  { provide: MSAL_INTERCEPTOR_CONFIG,useFactory: MSALInterceptorConfigFactory},


  MsalService,
  MsalGuard,
  MsalBroadcastService
],
  bootstrap: [AppComponent]
})
export class AppModule { }
